import React from 'react';

function Quote() {
  return (
    <div className="container quote">
      <p>
        Mathematics is not about numbers, equations, computations,
        {' '}
        <br />
        {' '}
        or
        algorithm; it is about understanding. -William Paul Thurston.
      </p>
    </div>
  );
}

export default Quote;
